import React, { useState, useEffect, createRef, useRef } from "react";
import "./Upload.css";
import axios from "axios";
import Spinner from "../components/common/spinner/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { uploadFile } from "../services/apis";

export default function Upload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [spinnerButton, setSpinnerButton] = useState(false);
  const [displayInformationsBlock, setSisplayInformationsBlock] =
    useState(false);
  const [uploadStatus, setUploadStatus] = useState({
    status: "",
    message: "",
  });

  async function onSubmit(e) {
    e.preventDefault();
    setSpinnerButton(true);

    const data = new FormData();
    data.append("file", selectedFile);
    var uploadFileResult;

    try {
      // async function uploadFile() {
      //   const jwt = localStorage.getItem("jwt");
      //
      //   const headers = {
      //     accept: "application/json",
      //     Authorization: `Bearer ` + jwt,
      //   };
      //
      //   return await axios.post(
      //     //"https://dev.llh-wow.com/api/data/upload-file",
      //     "http://localhost:5000/api/data/upload-file",
      //     data,
      //     {
      //       headers,
      //     }
      //   );
      // }
      const jwt = localStorage.getItem("jwt");
      uploadFileResult = await uploadFile(jwt, data);
      setUploadStatus({ status: "success", message: uploadFileResult.message });
      setSisplayInformationsBlock(true);
    } catch (ex) {
      if (ex && ex.response && ex.response.data && ex.response.data.message) {
        setUploadStatus({ status: "error", message: ex.response.data.message });
        setSisplayInformationsBlock(true);
      }
    }
    setSpinnerButton(false);
  }

  function fileNames() {
    if (selectedFile) {
      return selectedFile.name;
    }
    return null;
  }

  const onChangeHandler = (file) => {
    setSelectedFile(file);
  };

  return (
    <>
      {displayInformationsBlock ? (
        <div
          className={
            uploadStatus.status == "error" ? "block error" : "block success"
          }
        >
          <div className="errorBlock__content">
            <div className="errorBlock__iconContainer">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="info"
                className="svg-inline--fa fa-info fa-w-6 "
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 192 512"
              >
                <path
                  fill="currentColor"
                  d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                ></path>
              </svg>
            </div>
            <div className="errorBlock__container">
              <div className="errorBlock__title">info</div>
              <div className="errorBlock__message"> {uploadStatus.message}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <div>
        <form onSubmit={onSubmit} className="form-upload">
          <div className="upload-block">
            <div>You can upload your file here : </div>
            <input
              id="file"
              type="file"
              onChange={(e) => onChangeHandler(e.target.files[0])}
              accept=".xlsx"
            />
            <label htmlFor="file" className="form-upload-label">
              <span tabIndex="0" role="button" aria-controls="filename">
                Upload file(s):{" "}
              </span>
            </label>
            {fileNames()}
          </div>

          <button type="submit" className="btn upload">
            {spinnerButton ? (
              <FontAwesomeIcon
                icon={faSpinner}
                className="spinner-button"
                spin
              />
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
    </>
  );
}
